module.exports = __webpack_public_path__ + "static/media/bike.fe5042bf.jpeg";